// src/api/onboarding.js
import { api } from "../lib/apiClient";

/**
 * Sauvegarde une étape de l'onboarding
 * @param {string} step - Nom de l'étape (activites, matieres, metiers, etat, attentes, fierte)
 * @param {Object} data - Données de l'étape
 * @returns {Promise<{ success: boolean }>}
 */
export async function saveOnboardingStep(step, data) {
  const response = await api.patch("/ciaov2_onboarding_survey_user", {
    step,
    data
  });
  return response.data;
}

/**
 * Finalise l'onboarding (marque comme complété)
 * @returns {Promise<{ success: boolean }>}
 */
export async function completeOnboardingApi() {
  const response = await api.post("/ciaoV2_onboarding_survey_user/complete");
  return response.data;
}

/**
 * Récupère les données d'onboarding de l'utilisateur
 * @returns {Promise<Object>}
 */
export async function getOnboardingData() {
  const response = await api.get("/ciaoV2_onboarding_survey_user");
  return response.data;
}
